export const environment = {
  cognito: {
    userPoolId: 'eu-west-1_OscEpMJSG',
    clientId: '1rhev7v2ml7p8hbaumbtvq3bsk',
    region: 'eu-west-1',
    domain: 'suppliermanagementapi-test.auth.eu-west-1.amazoncognito.com',
  },
  apiUrl: 'https://supplier-mgmt-api-app-test-eun.politeforest-0164d73f.northeurope.azurecontainerapps.io',
  publicResourcesUrl: 'https://stslmtesteun.blob.core.windows.net/public/',
  applicationInsights: {
    enabled: true,
    cloudRoleName: 'Supplier Management WebApp',
  },
};
